// extracted by mini-css-extract-plugin
module.exports = {"view":"UserActivities_view__UzxeZ","detailLevel":"UserActivities_detailLevel__2vhfN","activities":"UserActivities_activities__27VJX"};